<template>
  <div>
    <slot />
  </div>
</template>

<script>
import useUser from 'states/useUser'

import { provide } from '@vue/composition-api'

export const UserDataSymbol = Symbol('User data id')

export default {
  setup() {
    const { user } = useUser()
    provide(UserDataSymbol, user)
  },
}
</script>
